import * as React from "react";
import PropTypes from 'prop-types';

const SvgBonusEvent = props => {
  if (props.id !== "_svgbonusevent") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><rect x={1.75} y={4.75} width={20.5} height={16.5} rx={1.25} stroke="#E71324" strokeWidth={1.5} /><path fill="#E71324" d="M6 2h2v5H6zM4 10h4v4H4zM16 2h2v5h-2z" /></svg>;
};

SvgBonusEvent.displayName = "_svgbonusevent";
SvgBonusEvent.propTypes = {
  id: PropTypes.string
};
SvgBonusEvent.defaultProps = {
  id: ''
};
export default SvgBonusEvent;